import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { LoginPage } from '@/pages/LoginPage'
import { DashboardPage } from '@/pages/DashboardPage'
import { TenantsPage } from '@/pages/TenantsPage'
import { TenantDetailPage } from '@/pages/TenantDetailPage'
import { ApplicationsPage } from '@/pages/ApplicationsPage'
import { AdminUsersPage } from '@/pages/AdminUsersPage'
import { PackagesPage } from '@/pages/PackagesPage'
import { SystemHealthPage } from '@/pages/SystemHealthPage'
import { AuditLogPage } from '@/pages/AuditLogPage'
import { SettingsPage } from '@/pages/SettingsPage'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { token, isAdmin } = useAuthStore()

  if (!token || !isAdmin) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

export function App() {
  const { token } = useAuthStore()

  return (
    <Routes>
      <Route
        path="/login"
        element={token ? <Navigate to="/" replace /> : <LoginPage />}
      />

      <Route
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<DashboardPage />} />
        <Route path="/tenants" element={<TenantsPage />} />
        <Route path="/tenants/:id" element={<TenantDetailPage />} />
        <Route path="/applications" element={<ApplicationsPage />} />
        <Route path="/admin-users" element={<AdminUsersPage />} />
        <Route path="/packages" element={<PackagesPage />} />
        <Route path="/system-health" element={<SystemHealthPage />} />
        <Route path="/audit-log" element={<AuditLogPage />} />
        <Route path="/settings" element={<SettingsPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
